import React, { Component, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect as RouterRedirect } from 'react-router-dom';
import Draggable from 'react-draggable';
import LogRocket from 'logrocket';

// import { FaTimes } from 'react-icons/fa';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import history from './utils/history';

import OnboardingStart from './containers/onboarding/OnboardingStart';
import Carousel from './containers/onboarding/OnboardingCarousel';
import OnboardingCorporate from './containers/onboarding/OnboardingCorporate';
import OnboardingVerifyOtp from './containers/onboarding/OnboardingVerifyOtp';
import OneLastStep from './containers/onboarding/OneLastStep';
import SubscriptionActivated from './containers/onboarding/SubscriptionActivated';
import OnboardingEmail from './containers/onboarding/OnboardingEmail.js';
import CorporateBenefitsActivated from './containers/onboarding/CorporateBenefitsActivated';
import HomeTabContainer from './containers/home/HomeTabContainer';
import UpSellAhcNavigator from './containers/upsell-ahc/UpSellAhcNavigator';
import SelectUserType from './containers/onboarding/SelectUserType';
import MealLogNavigator from './containers/meal-log/MealLogNavigator';
import WhatsNotCovered from './containers/policy/WhatsNotCovered';
import RewardsNavigator from './containers/rewards/RewardsNavigator';
import HraNavigator from './containers/hra/HraNavigator';
import PhonepePaymentProcessing from './containers/common/PhonepePaymentProcessing';
import SsoContainer from './containers/home/SsoContainer';
import AuthTokenContainer from './containers/home/AuthTokenContainer';
// import OnboardingHome from './containers/onboarding/OnboardingHome';
import { RegularText, BoldText } from './components/common/Text';
import StyledTappable from './components/common/StyledTappable';
import ErrorModal from './containers/common/ErrorModal';
// import modalIcon from './images/common/paymentFail.svg';
import errorModalBg from './images/common/error-modal-bg.svg';
import errorModalIcon from './images/common/error-modal.svg';
import closeIcon from './images/lab-test/closeBlack.svg';
import {
  closeFileViewer,
  hideError,
  setAppConfig,
  clearAxiosCache,
} from './actions/index';
import ReferContainer from './containers/home/ReferContainer';
import { appConfig, callMetaApi } from './services';
import BotChatContainer from './containers/bot/BotChatContainer';
// import ReimbursementNavigator from './containers/reimbursement/ReimbursementNavigator';
import AccountActivationForm from './containers/common/AccountActivationForm';
import ClaimsNavigator from './containers/claims/ClaimsNavigator';
// import PharmacyNavigator from './containers/pharmacy/PharmacyNavigator';
import SupportWindow from './containers/Support';
import BuyingJourneyNavigator from './containers/buying-journey/BuyingJourneyNavigator';
import VideoCallContainer from './containers/consultation/VideoCallContainer';
// analytics
import { initializeAmplitudeClient } from './utils/logEvent';
import VideoCallScreen from './containers/consultation/VideoCallScreen';
import LoadingSkeleton from './components/common/Skeleton/App';
import ManageDependents from './containers/home/ManageDependents';
//CSS
import './App.css';
import './comman-txt.css';
import './spacing.css';
import './Calendar.css';
import { VideoCallRedirector } from './containers/consultation/VideoCallRedirector';
import CovidPackages from './containers/lab-test/CovidPackages';
import CovidHomeNavigator from './containers/covid-home/CovidHomeNavigator';
import config from './config';
import WaterLog from './containers/water-log/WaterLog';
import PhysioProgram from './containers/physiotherapy-program/PhysioProgram';
import Redirect from './containers/deep-link/Redirect';
import HealthContentNavigator from './containers/health-content/HealthContentNavigator';
// import PodcastAlbumPage from './containers/health-content/PodcastAlbumPage';
import MaternityCareProgramNavigator from './containers/maternity-care-program/MaternityCareProgramNavigator';
import PristynCareNavigator from './containers/pristyn-care/pristynCareNavigator';
import BackdropCircleIcon from './images/BackdropCircles.svg';
import NewOnboardingHome from './containers/onboarding/NewOnboardingHome';
import NewVisitLogo from './images/common/visitfulllogo.png';
import SideNavigator from './components/home/SideNavigator';
import AccountSection from './components/home/AccountSection';
import EditAccount from './containers/home/EditAccount';
// import ReimbursementStart from './containers/reimbursement/ReimbursementStart';
import MyOrders from './containers/lab-test/AllOrders';
import OnlineConsultationStartPreview from './containers/consultation/OnlineConsultationStartPreview';
import PharmacyOrders from './containers/pharmacy/PharmacyOrders';
import ConsultationStartPreview from './containers/consultation/ConsultationStartPreview';
import RedirectUpdation from './containers/deep-link/RedirectUpdation';
import ReverifyOtp from './containers/onboarding/ReverifyOtp';
// import OfflineQRScan from './containers/deep-link/OfflineQRScan';
import NotFoundPage from './components/home/NotFoundPage';
import RaiseInconvenience from './containers/consultation/RaiseInconvenience';
import ChatRedirector from './containers/consultation/ChatRedirector';
import { Download } from './containers/common/Download.js';
import UserBenefits from './containers/home/UserBenefits.js';
import FileViewerModal from './components/common/FileViewer.js';
import FileViewerPage from './containers/common/FileViewerPage.js';
import FeedBackContainer from './components/consultations/FeedBackContainer';
import ConsultationChatOnlyContainer from './containers/consultation/ConsultationChatOnlyContainer.js';
import LinkNewBenefit from './containers/home/LinkNewBenefit.js';
import ErrorBoundary from './ErrorBoundary';
import LoadingComponent from './components/common/LoadingComponent';
import OnboardingVerifyEmailOtp from './containers/onboarding/OnboardingVerifyEmailOtp.js';
import ScanAndPayHomepage from './containers/scan-and-pay-frontend/ScanAndPayHomepage.js';

//Example of code splitting
//Lazy loading will split the code in separate chunks
const LabTestNavigator = lazy(
  () =>
    import(
      './containers/lab-test/LabTestNavigator' /* webpackChunkName: "labs-v2" */
    )
);

const ForYouPage = lazy(() => import('./containers/lab-test/ForYouPage'));
const ForYouProductDetail = lazy(
  () => import('./containers/lab-test/v2/Pages/ForYou/components/ProductDetail')
);
const ConsultationNavigator = lazy(
  () =>
    import(
      './containers/consultation/ConsultationNavigator' /* webpackChunkName: "consultation" */
    )
);
const ReimbursementNavigator = lazy(
  () =>
    import(
      './containers/reimbursement/ReimbursementNavigator' /* webpackChunkName: "reimbursement" */
    )
);

const NewReimbursementNavigator = lazy(
  () =>
    import(
      './containers/new-reimbursement/Navigator.js' /* webpackChunkName: "new-reimbursement" */
    )
);

const PharmacyNavigator = lazy(
  () => import('./containers/pharmacy/PharmacyNavigator')
);

const CultNavigator = lazy(() => import('./containers/cult/CultNavigator'));

// GoodFlip Navigator home
const GoodFlipNavigator = lazy(
  () => import('./containers/goodFlip/GoodFlipNavigator')
);

const VisionNavigator = lazy(
  () => import('./containers/cashless-vision/VisionNavigator')
);

const HospitalizationNavigator = lazy(
  () => import('./containers/hospitalization/HospitalizationNavigator')
);

const GymNavigator = lazy(
  () => import('./containers/gym-bookings/Navigator.jsx')
);

const FitPassNavigator = lazy(
  () => import('./containers/fit-pass/Navigator.jsx')
);

const GymEnrolmentNavigator = lazy(
  () => import('./containers/gym-enrolment/Navigator.jsx' /* webpackChunkName: "gym-enrolment" */)
);

const HcpNavigator = lazy(
  () => import('./containers/hcp-journey/HcpNavigator')
);

const DentalNavigator = lazy(
  () => import('./containers/dental/DentalNavigator.js')
);

const VaccinationNavigator = lazy(
  () => import('./containers/vaccination/VaccinationNavigator.js')
);

const ConceirgeNavigator = lazy(
  () => import('./containers/conceirge-service/ConceirgeNavigator.js')
);

const MoodJournalNavigator = lazy(
  () => import('./containers/mood-journal/MoodJournalNavigator.js')
);
const EAPNavigator = lazy(() => import('./containers/eap/EAPNavigator.js'));
const JoyeNavigator = lazy(() => import('./containers/joye/JoyeNavigator.js'));

const WomenWellnessNavigator = lazy(
  () => import('./containers/women-wellness/WomenWellnessNavigator.js')
);

const CashlessPhysioRoutes = lazy(
  () =>
    import(
      './containers/cashless-physio/routes' /* webpackChunkName: "cashless-physio" */
    )
);
const ScanAndPayHomePageNavigator = lazy(
  () =>
    import('./containers/scan-and-pay-frontend/ScanAndPayHomePageNavigator.js')
);

const OuterContainer = styled.div`
  z-index: 90;
  display: flex;
  flex: 1 0;
  overflow: hidden;
  background: white;
`;

const OuterDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  font-family: Arial, sans-serif;
  background-color: #f0f0f0;
  width: 100%;
`;

const ContainerDiv = styled.div`
  text-align: center;
  padding: 20px;
`;

const HeaderText = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: #333;
`;

const Paragraph = styled.p`
  color: #666;
  font-size: 16px;
`;

const ModalContainer = styled.div`
  height: 100svh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 335px;
  padding: 1.125rem 1.25rem 1.875rem 1.25rem;
  border-radius: 12px;
  margin: 0 1rem;
  text-align: center;
`;

const CloseContainer = styled(StyledTappable)`
  align-self: flex-end;
`;

const ModalIcon = styled.img`
  width: 5.7rem;
`;

const ModalText = styled(RegularText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #302e6b;
`;

const ModalTitle = styled(BoldText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  line-height: 20px;
  color: #131836;
  margin: 0.9375rem 0rem 0.375rem;
`;

// const VideoMax = styled.div`
// min-width: 450px;
// max-width: 450px;
// `;

// const VideoMin = styled.div`
// min-width: 200px;
// max-width: 200px;
// position: fixed;
// right: 3%;
// bottom: 3%;
// height: 30vh;
// z-index: 100000,
// border-radius: 10px;
// `

const videoCallMaximizedCss = {
  display: 'flex',
  flex: '400',
  overflow: 'scroll',
  zIndex: '100000',
};

const videoCallMinimizedCss = {
  minWidth: '200px',
  maxWidth: '200px',
  position: 'fixed',
  right: '3%',
  bottom: '3%',
  height: '30vh',
  overflow: 'scroll',
  zIndex: '100000',
  borderRadius: '10px',
};

const getUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');

  const utmParams = {
    utmSource,
    utmMedium,
    utmCampaign,
  };

  // Save to local storage if UTM params exist
  if (utmSource || utmMedium || utmCampaign) {
    localStorage.setItem('utmParams', JSON.stringify(utmParams));
  }

  return utmParams;
};

class App extends Component {
  intervalId = null;

  startCountdown = () => {
    if (this.intervalId) return;
    this.intervalId = setInterval(() => {
      const { timeoutInSeconds, setTimeoutValue } = this.props;
      if (timeoutInSeconds > 0) {
        setTimeoutValue(timeoutInSeconds - 1);
      } else {
        this.stopCountdown();
      }
    }, 1000);
  };

  stopCountdown = () => {
    clearInterval(this.intervalId);
    this.intervalId = null;
  };

  formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  };

  constructor(props) {
    super(props);

    this.state = {
      modalVisible: true,
      isVideoCallMinimized: false,
    };

    this.amplitudeClient = initializeAmplitudeClient();
  }

  componentDidMount = () => {
    window.__REACT_MOUNTED__ = true;
    if (this.props.timeoutInSeconds > 0) {
      this.startCountdown();
    }
    // Optional cleanup
    if (window.__reactMountCheckTimer__) {
      clearTimeout(window.__reactMountCheckTimer__);
      delete window.__reactMountCheckTimer__;
    }

    this.initializeCleverTap();
    this.props.hideModal();
    this.amplitudeClient.init();
    const { authToken, setAppConfig, userId, sponsorName, userInfo } =
      this.props;

    getUTMParams();

    const params = new URLSearchParams(window.location.search);
    const newAuthToken = params.get('authToken');
    // Replace existing auth token in case of auth-login from link/app-webview
    if (newAuthToken) {
      console.log('first time authToken', this.props);
      this.props.dispatch({
        type: 'AUTH_TOKEN',
        payload: newAuthToken,
      });
    }
    window.updateFitnessPermissions = (fitnessPermission, step, sleep) => {
      const data = {
        permissionForGoogleFit: fitnessPermission,
        currentSteps: step,
        currentSleep: sleep,
      };
      // store.dispatch(setGoogleFitPermission(data));
    };
    if (userId) {
      // set amplitude userProp
      this.amplitudeClient.initUser(userInfo);
      this.amplitudeConfigured = true;
      // Set GA properties
      this.gtagConfigured = true;
      window.gtag('config', process.env.REACT_APP_GA_ID, {
        user_id: userId,
        app_name: 'VISIT PWA',
        app_version: '1.0.0',
        custom_map: {
          dimension1: 'sponsor_dimension',
        },
        sponsor_dimension: sponsorName,
      });

      LogRocket.identify(userId, {
        name: userInfo.userName,
        email: userInfo.userEmail,
      });
    }
    if (
      this.props.loginState === 'LOGGED_IN' &&
      authToken &&
      !newAuthToken && // when auth in URL - do not call config api from App.js
      !this.props.tatva
    ) {
      // New auth token is going to be present in with loginWithAuth as well as Tatva /chat-only
      // Login with auth comes from Web - so allow login from sagas where config api will be called and manual reload will not work - so config call here is not needed
      // Tatva chat-only - also occurs in webview - so config call with their token is not needed
      appConfig(newAuthToken || authToken)
        .then((res) => {
          setAppConfig(res.config);
        })
        .catch((err) => {
          console.log(err);
        });
      callMetaApi(authToken).catch((err) => {
        console.log(err);
      });
    }
    // if (this.props.userInfo) {
    //   this.initializeFreshDesk();
    // }
  };

  componentDidUpdate(prevProps) {
    const { timeoutInSeconds, timeoutKey, userId, sponsorName, userInfo } =
      this.props;
    const prevTimeoutKey = prevProps.timeoutKey;
    const timeoutRestarted = prevTimeoutKey !== timeoutKey;

    // 🕒 Restart timer if timeout value changed OR a new timeoutKey was set
    if (timeoutInSeconds > 0 && timeoutRestarted) {
      this.stopCountdown(); // Clear any previous countdown
      this.startCountdown(); // Start a fresh countdown
    }

    // 🛑 Stop countdown when timer hits 0
    if (timeoutInSeconds === 0 && prevProps.timeoutInSeconds > 0) {
      this.stopCountdown();
    }

    if (!this.gtagConfigured && userId) {
      this.gtagConfigured = true;
      window.gtag('config', process.env.REACT_APP_GA_ID, {
        user_id: userId,
        app_name: 'VISIT PWA',
        app_version: '1.0.0',
        custom_map: {
          dimension1: 'sponsor_dimension',
        },
        sponsor_dimension: sponsorName,
      });
    }
    if (!this.amplitudeConfigured && userId) {
      this.amplitudeConfigured = true;
      // set amplitude userProp
      this.amplitudeClient.initUser(userInfo);
    }
  }

  componentWillUnmount() {
    this.stopCountdown();
  }

  initializeCleverTap = () => {
    if (window.clevertap) {
      window.clevertap.account.push({ id: config.clevertapId });
    }
  };

  handleVideoCallMinimize = () => {
    this.setState({
      isVideoCallMinimized: !this.state.isVideoCallMinimized,
    });
  };

  hideModal = () => {
    this.props.hideModal();
  };

  render() {
    const { authToken, loginState } = this.props;
    const { startCall, videoCallPayload, userExit } = this.props.video;

    // if (
    //   window.location.pathname === '/lab-test/for-you' ||
    //   window.location.pathname === '/lab-test/product-detail'
    // ) {
    //   return (
    //     <Router history={history}>
    //       <Suspense fallback={<LoadingComponent />}>
    //         <Route path="/lab-test/for-you" component={ForYouPage} />
    //         <Route path="/lab-test/product-detail" component={ForYouProductDetail} />
    //       </Suspense>
    //     </Router>
    //   );
    // }

    return (
      <OuterContainer id="sub-root">
        <div
          style={{
            minWidth: '320px',
            position: 'absolute',
            left: '5%',
            overflow: 'hidden',
          }}
          id="brand-logo"
        >
          <img
            src={NewVisitLogo}
            style={{
              width: '180px',
              marginRight: '140px',
            }}
            alt="visit logo"
          />
        </div>
        <Router history={history}>
          <Suspense fallback={<LoadingSkeleton />}>
            <>
              {loginState === 'LOGGED_IN' &&
                authToken &&
                this.props.showNavigator && (
                  <div
                    id="brand-logo"
                    style={{
                      minWidth: '325px',
                      // width: '325px',
                      position: 'absolute',
                      left: '5%',
                      top: '206px',
                      height: '100svh',
                      overflowY: 'scroll',
                    }}
                  >
                    <div id={'sideNavigator'}>
                      <SideNavigator />
                    </div>
                  </div>
                )}
              {startCall && videoCallPayload ? (
                <Draggable
                  position={!this.state.isVideoCallMinimized && { x: 0, y: 0 }}
                  disabled={!this.state.isVideoCallMinimized}
                >
                  <div
                    style={
                      this.state.isVideoCallMinimized
                        ? videoCallMinimizedCss
                        : videoCallMaximizedCss
                    }
                  >
                    <VideoCallContainer
                      videoCallPayload={videoCallPayload}
                      handleVideoCallMinimize={this.handleVideoCallMinimize}
                    />
                  </div>
                </Draggable>
              ) : userExit ? (
                <OuterDiv>
                  <ContainerDiv>
                    <HeaderText>Your Consultation has ended</HeaderText>
                    <Paragraph>Thank you for your time.</Paragraph>
                  </ContainerDiv>
                </OuterDiv>
              ) : (
                ''
              )}
              <ErrorBoundary>
                <Switch>
                  <Route path="/" exact component={NewOnboardingHome} />
                  <Route path="/carousel" component={Carousel} />
                  <Route path="/login" component={OnboardingStart} />
                  <Route path="/verify-otp" component={OnboardingVerifyOtp} />
                  <Route
                    path="/verify-email-otp"
                    component={OnboardingVerifyEmailOtp}
                  />
                  <Route path="/re-verify-otp" component={ReverifyOtp} />
                  <Route path="/one-last-step" component={OneLastStep} />
                  <Route
                    path="/opd-activated"
                    component={SubscriptionActivated}
                  />
                  <Route
                    path="/consultation/chat-only"
                    component={ConsultationChatOnlyContainer}
                  />
                  <Route path="/select-user" component={SelectUserType} />
                  <Route
                    path="/corporate-onboard"
                    component={OnboardingCorporate}
                  />
                  <Route path="/email-signup" component={OnboardingEmail} />
                  <Route path="/additional-info" component={WhatsNotCovered} />
                  <Route
                    path="/corporate-activated"
                    component={CorporateBenefitsActivated}
                  />
                  <Route path="/refer" component={ReferContainer} />
                  <Route path="/home" component={HomeTabContainer} />
                  <Route path="/link-new-benefit" component={LinkNewBenefit} />
                  <Route
                    path="/consultations/feedback"
                    component={FeedBackContainer}
                  />
                  <Route path="/bot" component={BotChatContainer} />
                  <Route
                    path="/consultation"
                    component={ConsultationNavigator}
                  />
                  <Route path="/dental" component={DentalNavigator} />
                  <Route path="/lab-test/for-you" component={ForYouPage} />
                  <Route path="/lab-test" component={LabTestNavigator} />
                  <Route
                    path="/cashless-physiotherapy"
                    component={CashlessPhysioRoutes}
                  />{' '}
                  <Route path="/ahc-upsell" component={UpSellAhcNavigator} />
                  <Route
                    path="/reimbursement"
                    component={ReimbursementNavigator}
                  />
                  <Route
                    path="/new-reimbursement"
                    component={NewReimbursementNavigator}
                  />
                  <Route path="/rewards" component={RewardsNavigator} />
                  <Route
                    path="/hospitalization"
                    component={HospitalizationNavigator}
                  />
                  <Route path="/gym" component={GymNavigator} />
                  <Route
                    path="/fit-pass"
                    render={(props) => (
                      <Suspense fallback={null}>
                        <FitPassNavigator {...props} />
                      </Suspense>
                    )}
                  />
                  {/* Payment gateway redirects here after payment — forward
                      to the gym-enrolment success page preserving orderId.
                      This MUST come before the non-exact /gym-enrolment route
                      below, otherwise the Switch picks the Navigator first. */}
                  <Route
                    path="/gym-enrolment/status"
                    render={({ location }) => (
                      <RouterRedirect
                        to={{
                          pathname: '/gym-enrolment/success',
                          search: location.search,
                        }}
                      />
                    )}
                  />
                  <Route
                    path="/gym-enrolment"
                    render={(props) => (
                      <Suspense fallback={null}>
                        <GymEnrolmentNavigator {...props} />
                      </Suspense>
                    )}
                  />
                  <Route path="/sso" component={SsoContainer} />
                  <Route path="/:clientId/sso" component={SsoContainer} />
                  <Route path="/auth-login" component={AuthTokenContainer} />
                  <Route path="/logmeal" component={MealLogNavigator} />
                  <Route path="/hra" component={HraNavigator} />
                  <Route path="/hcp" component={HcpNavigator} />
                  <Route path="/vaccination" component={VaccinationNavigator} />
                  <Route path="/conceirge" component={ConceirgeNavigator} />
                  <Route
                    path="/mood-journal"
                    component={MoodJournalNavigator}
                  />
                  <Route path="/eap" component={EAPNavigator} />
                  <Route path="/joye" component={JoyeNavigator} />
                  <Route path="/video" component={VideoCallScreen} />
                  <Route
                    path="/processing-payment"
                    component={PhonepePaymentProcessing}
                  />
                  <Route path="/claims" component={ClaimsNavigator} />
                  <Route path="/pharmacy" component={PharmacyNavigator} />
                  <Route path="/cult" component={CultNavigator} />
                  <Route path="/vision" component={VisionNavigator} />
                  <Route path="/support" component={SupportWindow} />
                  <Route
                    path="/activate-account"
                    component={AccountActivationForm}
                  />
                  <Route
                    path="/buying-journey"
                    component={BuyingJourneyNavigator}
                  />
                  <Route
                    path="/manage-dependents"
                    component={ManageDependents}
                  />
                  <Route path="/video-call" component={VideoCallContainer} />
                  <Route path="/c" component={VideoCallRedirector} />
                  <Route path="/chat" component={ChatRedirector} />
                  <Route path="/covid-packages" component={CovidPackages} />
                  <Route path="/covid-home" component={CovidHomeNavigator} />
                  <Route path="/covid-swiggy" component={CovidHomeNavigator} />
                  <Route path="/covid-gartner" component={CovidHomeNavigator} />
                  <Route path="/water-details" component={WaterLog} />
                  <Route path="/physio-program" component={PhysioProgram} />
                  <Route
                    path="/maternity-care"
                    component={MaternityCareProgramNavigator}
                  />
                  <Route path="/au-benefits" component={UserBenefits} />
                  <Route path="/redirect" component={Redirect} />
                  <Route path="/update-details" component={RedirectUpdation} />
                  <Route
                    path="/qr/offline-scan"
                    component={ScanAndPayHomepage}
                  />
                  <Route
                    path="/health-content"
                    component={HealthContentNavigator}
                  />
                  <Route path="/edit-account" component={EditAccount} />
                  <Route path="/labs/orders" component={MyOrders} />
                  <Route
                    path="/online/orders"
                    component={OnlineConsultationStartPreview}
                  />
                  <Route
                    path="/medicine/orders"
                    exact
                    component={PharmacyOrders}
                  />
                  <Route
                    path="/offline/orders"
                    component={ConsultationStartPreview}
                  />
                  <Route
                    path="/offline/raise-inconvenience/:requestId"
                    component={RaiseInconvenience}
                  />
                  <Route
                    path="/pristyn-care"
                    component={PristynCareNavigator}
                  />
                  <Route path="/good-flip" component={GoodFlipNavigator} />
                  <Route path="/file-view" component={FileViewerPage} />
                  {/* This route handles the success and failure of payments of DSA users. */}
                  <Route path="/download" component={Download} />
                  {/* Women Wellness Routes */}
                  <Route
                    path="/women-wellness"
                    component={WomenWellnessNavigator}
                  />
                  {/* Scan and Pay Routes */}
                  <Route
                    path="/scan-and-pay"
                    component={ScanAndPayHomePageNavigator}
                  />
                  <Route path="*" component={NotFoundPage} />
                </Switch>
              </ErrorBoundary>
            </>
          </Suspense>
          {loginState === 'LOGGED_IN' &&
            authToken &&
            this.props.showNavigator &&
            !this.props.dontShowNavigator && (
              <div
                id="account-section"
                style={{
                  width: 'fit-content',
                  position: 'absolute',
                  right: '60px',
                  height: '100svh',
                  overflow: 'scroll',
                }}
              >
                <div>
                  <AccountSection
                    openEditAccount={() => history.push('/edit-account')}
                  />
                </div>
              </div>
            )}
        </Router>
        {this.props.appError.hasError && (
          <ErrorModal>
            <ModalContainer>
              <ModalBody>
                <CloseContainer onTap={this.hideModal}>
                  <img
                    src={closeIcon}
                    alt="close"
                    width="32"
                    height="32"
                    className="cursor-pointer"
                  />
                </CloseContainer>
                <div
                  style={{
                    backgroundImage: `url(${errorModalBg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '114px 114px',
                    backgroundPosition: 'center center',
                    textAlign: 'center',
                  }}
                >
                  <ModalIcon
                    src={errorModalIcon}
                    style={{ width: '164px', height: '116px' }}
                  />
                </div>
                <ModalTitle>{this.props.appError.errorTitle}</ModalTitle>
                <ModalText>{this.props.appError.errorDesc}</ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
        {this.props?.isOpen && <FileViewerModal />}
        <div id={'backdrop-icon'}>
          <img
            src={BackdropCircleIcon}
            style={{
              width: '200%',
              height: '100%',
              position: 'absolute',
              bottom: '-55%',
              right: '-15%',
              zIndex: '-50',
              userSelect: 'none',
            }}
            alt="backdrop"
          />
        </div>
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  sponsorName: state.user.sponsorName,
  appError: state.app.appError,
  userInfo: state.user,
  sponsorLogo: state.app.config.sponsorLogo,
  showNavigator: state.app.showNavigator,
  dontShowNavigator: state.app.dontShowNavigator,
  video: state.video,
  isOpen: state.app?.appFileViewer?.isOpen,
  tatva: state.app.tatva,
  timeoutInSeconds: state.linkBenefits.timeoutInSeconds,
  timeoutKey: state.linkBenefits.timeoutKey,
});

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => {
    dispatch(hideError());
    dispatch(closeFileViewer());
  },
  removeAxiosCache: () => {
    dispatch(clearAxiosCache());
  },
  setAppConfig: (config) => {
    dispatch(setAppConfig(config));
  },
  setTimeoutValue: (seconds) => {
    dispatch({ type: 'SET_TIMEOUT_VERIFICATION', payload: seconds });
  },
  dispatch: dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
